<ng-container *ngIf="!isFinanceBenin; else moduleIndisponible">
  <div
    class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex"
  >
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div
      class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
    >
      <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
        <div *ngIf="nomrole !== 'finance'" class="w-full">
          <div
            class="self-stretch flex-col justify-start items-center gap-6 flex"
          >
            <div
              class="self-stretch flex-col justify-start items-start gap-6 flex"
            >
              <div
                class="self-stretch flex-col justify-start items-start gap-5 flex"
              >
                <div
                  class="self-stretch justify-start items-start gap-4 inline-flex lg:flex-row flex-col"
                >
                  <div
                    class="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex"
                  >
                    <div
                      class="self-stretch text-gray-900 text-4xl font-semibold leading-[38px]"
                    >
                      Gestion des Activités
                    </div>
                    <div
                      class="self-stretch text-slate-600 text-base font-interRegular leading-normal mb-2"
                    >
                      Vous pouvez gérer ici les activités du programme en cours
                    </div>
                  </div>
                  <div class="justify-start items-center gap-3 flex">
                    <a
                      class="transition hover:bg-gray-200 px-3 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex"
                      [routerLink]="['create-activity']"
                    >
                      <div class="relative">
                        <img
                          src="assets/icons/plus.png"
                          alt="plus"
                          style="width: 22px; height: 22px"
                        />
                      </div>
                      <div
                        class="text-slate-700 font-interSemibold leading-tight mr-0 md:mr-3"
                      >
                        Créer une activité
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tableau pour les gestionnaire -->

        <div class="create-activity-one cst-content-ctnr">
          <div
            class="w-full dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex"
          >
            <!-- ===== DÉBUT MODIF : barre de filtres (recherche, dates, type, pays) ===== -->
            <form
              [formGroup]="filterForm"
              class="ga-filtres"
              (ngSubmit)="applyFilter()"
            >
              <!-- Recherche par mot clé -->
              <div class="ga-recherche">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  aria-hidden="true"
                >
                  <circle cx="11" cy="11" r="7" />
                  <path d="M20 20l-3.5-3.5" />
                </svg>
                <input
                  [(ngModel)]="searchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  (input)="applyFilterBYkEY($event)"
                  id="nomactivite"
                  type="text"
                  placeholder="Rechercher une activité par nom ou mot clé"
                  class="ga-input ga-input--recherche"
                />
              </div>

              <div class="ga-grille">
                <div class="ga-champ">
                  <label for="fromDate" class="ga-label">Date de début</label>
                  <input
                    formControlName="fromDate"
                    id="fromDate"
                    type="date"
                    class="ga-input"
                  />
                </div>

                <div class="ga-champ">
                  <label for="toDate" class="ga-label">Date de fin</label>
                  <input
                    formControlName="toDate"
                    id="toDate"
                    type="date"
                    class="ga-input"
                  />
                </div>

                <div class="ga-champ">
                  <label for="byType" class="ga-label">Type d'activité</label>
                  <select
                    formControlName="byType"
                    id="byType"
                    class="ga-input ga-select"
                  >
                    <option value="">Tous les types</option>
                    <option
                      *ngFor="let type of activityType"
                      [value]="type.value"
                    >
                      {{ type.name | titlecase }}
                    </option>
                  </select>
                </div>

                <!-- ===== DÉBUT AJOUT : filtre par pays ===== -->
                <div class="ga-champ">
                  <span id="labelPaysFiltre" class="ga-label">Pays</span>
                  <div
                    class="ga-segment"
                    role="group"
                    aria-labelledby="labelPaysFiltre"
                  >
                    <button
                      *ngFor="let pays of PAYS_FILTRE"
                      type="button"
                      class="ga-segment__btn"
                      [class.ga-segment__btn--actif]="
                        paysFiltreActif(pays.code)
                      "
                      [attr.aria-pressed]="paysFiltreActif(pays.code)"
                      (click)="choisirPaysFiltre(pays.code)"
                    >
                      <span
                        *ngIf="pays.code"
                        class="ga-drapeau"
                        [ngClass]="'ga-drapeau--' + pays.code"
                        aria-hidden="true"
                      ></span>
                      {{ pays.libelle }}
                    </button>
                  </div>
                </div>
                <!-- ===== FIN AJOUT ===== -->
              </div>

              <div class="ga-actions">
                <span class="ga-compteur" *ngIf="nbFiltresActifs > 0">
                  {{ nbFiltresActifs }} filtre{{
                    nbFiltresActifs > 1 ? "s" : ""
                  }}
                  actif{{ nbFiltresActifs > 1 ? "s" : "" }}
                </span>
                <button
                  type="button"
                  class="ga-btn ga-btn--secondaire"
                  (click)="reset()"
                  [disabled]="nbFiltresActifs === 0 && !searchTerm"
                >
                  Réinitialiser
                </button>
                <button type="submit" class="ga-btn ga-btn--primaire">
                  Appliquer les filtres
                </button>
              </div>
            </form>
            <!-- ===== FIN MODIF ===== -->
          </div>
        </div>

        <!-- ===== DÉBUT AJOUT : bandeau d'erreur (cadenas, chargement de la liste) ===== -->
        <!-- Fixé en haut de l'écran : visible même quand la liste a défilé -->
        <div *ngIf="erreurListe" class="ga-alerte" role="alert">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5M12 16.5v.5" />
          </svg>
          <span class="ga-alerte__texte">{{ erreurListe }}</span>
          <button
            type="button"
            class="ga-alerte__fermer"
            (click)="fermerErreurListe()"
            aria-label="Fermer le message"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              aria-hidden="true"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
        <!-- ===== FIN AJOUT ===== -->

        <!-- ===== AJOUT : bandeau de succès (suppression, fermeture) ===== -->
        <div
          *ngIf="succesListe"
          class="ga-alerte ga-alerte--succes"
          role="status"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M8 12l3 3 5-6" />
          </svg>
          <span class="ga-alerte__texte">{{ succesListe }}</span>
          <button
            type="button"
            class="ga-alerte__fermer"
            (click)="fermerSuccesListe()"
            aria-label="Fermer le message"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              aria-hidden="true"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
        <!-- ===== FIN AJOUT ===== -->

        <div *ngIf="!loading" class="px-1 pt-6 overflow-x-scroll">
          <!-- ===== MODIF : QR code de l'atelier (confirmation puis affiche) ===== -->
          <app-qrcode-affiche
            *ngIf="showModalQRCode"
            [activite]="rowDATA"
            (fermer)="closeQRCoceModal()"
          ></app-qrcode-affiche>
          <!-- ===== FIN MODIF ===== -->
          <div
            style="z-index: -1"
            class="mat-elevation-z8 w-full text-sm text-left rtl:text-right text-gray-700 dark:text-gray-400"
          >
            <!-- ===== DÉBUT MODIF : liste des activités en cartes (remplace le tableau mat-table) ===== -->
            <div class="ga-liste">
              <div class="ga-liste__entete">
                <p>
                  <b
                    >{{ totalElements }} activité{{
                      totalElements > 1 ? "s" : ""
                    }}</b
                  >
                  · les plus récentes d'abord
                </p>
              </div>

              <article
                *ngFor="let row of listActivity; trackBy: trackParId"
                class="ga-carte"
                [class.ga-carte--passee]="estPassee(row)"
              >
                <!-- Bloc date -->
                <div class="ga-carte__date" aria-hidden="true">
                  <span class="ga-carte__jour">{{
                    row.openDate | date: "dd"
                  }}</span>
                  <span class="ga-carte__mois">{{
                    row.openDate | date: "MMM" : "" : "fr" | uppercase
                  }}</span>
                </div>

                <!-- Contenu -->
                <div class="ga-carte__contenu">
                  <div class="ga-carte__titre-ligne">
                    <button
                      type="button"
                      class="ga-carte__titre"
                      (click)="showActivityForGes(row)"
                    >
                      {{ row.nomActivity }}
                    </button>
                    <span
                      class="ga-pill"
                      [ngClass]="classeType(row.activityType)"
                    >
                      {{ libelleTypeActivite(row.activityType) | titlecase }}
                    </span>
                    <span
                      class="ga-pill"
                      [ngClass]="statutActivite(row).classe"
                    >
                      <i class="ga-point" aria-hidden="true"></i
                      >{{ statutActivite(row).libelle }}
                    </span>
                  </div>

                  <div class="ga-carte__infos">
                    <!-- Période -->
                    <span>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.6"
                        aria-hidden="true"
                      >
                        <rect x="3" y="5" width="18" height="16" rx="2" />
                        <path d="M3 10h18M8 3v4M16 3v4" />
                      </svg>
                      <ng-container
                        *ngIf="
                          row.closeDate && row.closeDate !== row.openDate;
                          else unSeulJour
                        "
                      >
                        {{ row.openDate | date: "d MMM" : "" : "fr" }} –
                        {{ row.closeDate | date: "d MMM yyyy" : "" : "fr" }}
                      </ng-container>
                      <ng-template #unSeulJour>{{
                        row.openDate | date: "d MMM yyyy" : "" : "fr"
                      }}</ng-template>
                    </span>

                    <!-- Heure -->
                    <span *ngIf="heureCourte(row.hours)">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.6"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="9" />
                        <path d="M12 7v5l3 2" />
                      </svg>
                      {{ heureCourte(row.hours) }}
                    </span>

                    <!-- Lieu -->
                    <span *ngIf="row.adresse" [title]="row.adresse">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.6"
                        aria-hidden="true"
                      >
                        <path
                          d="M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z"
                        />
                        <circle cx="12" cy="9" r="2.5" />
                      </svg>
                      <span class="ga-tronque">{{ row.adresse }}</span>
                    </span>

                    <!-- Pays -->
                    <span>
                      <i
                        class="ga-drapeau"
                        [ngClass]="'ga-drapeau--' + paysActivite(row)"
                        aria-hidden="true"
                      ></i>
                      {{ paysActivite(row) === "bj" ? "Bénin" : "Sénégal" }}
                    </span>
                  </div>

                  <p *ngIf="row.description" class="ga-carte__description">
                    {{ row.description }}
                  </p>
                </div>

                <!-- Actions -->
                <div class="ga-carte__actions">
                  <button
                    type="button"
                    class="ga-action"
                    title="Liste pour confirmation"
                    (click)="onViewActivity(row.id)"
                  >
                    <svg
                      class="ga-c-vert"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.6"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                    Confirmations
                  </button>

                  <button
                    type="button"
                    class="ga-action"
                    title="Liste des participants"
                    (click)="showListParticipants(row.id)"
                  >
                    <svg
                      class="ga-c-orange"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.6"
                      aria-hidden="true"
                    >
                      <circle cx="9" cy="8" r="3" />
                      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
                      <circle cx="17" cy="9" r="2.5" />
                      <path d="M15.5 14.3c2.9.3 5.5 2.2 5.5 5.2" />
                    </svg>
                    Participants
                  </button>

                  <span class="ga-separateur" aria-hidden="true"></span>

                  <!-- Afficher -->
                  <button
                    type="button"
                    class="ga-icone"
                    title="Afficher"
                    aria-label="Afficher l'activité"
                    (click)="showActivityForGes(row)"
                  >
                    <svg
                      class="ga-c-bleu"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                    </svg>
                  </button>

                  <!-- Ouvrir / fermer -->
                  <button
                    type="button"
                    class="ga-icone"
                    [title]="
                      row.isClosed ? 'Ouvrir l\'activité' : 'Fermer l\'activité'
                    "
                    [attr.aria-label]="
                      row.isClosed ? 'Ouvrir l\'activité' : 'Fermer l\'activité'
                    "
                    (click)="openClosureModal(row)"
                  >
                    <svg
                      *ngIf="row.isClosed"
                      class="ga-c-rouge"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                    <svg
                      *ngIf="!row.isClosed"
                      class="ga-c-vert"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.5"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13.5 10.5V6.75a4.5 4.5 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  </button>

                  <!-- QR code (Atelier Force-N) -->
                  <button
                    *ngIf="row.activityType == 'ATELIER_FORCEN'"
                    type="button"
                    class="ga-icone"
                    title="QR code"
                    aria-label="Afficher le QR code"
                    (click)="showPopupForQRCode(row)"
                  >
                    <svg
                      class="ga-c-indigo"
                      viewBox="-32 0 512 512"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
                      />
                    </svg>
                  </button>

                  <!-- Code de présence (types définis dans aCodePresence) -->
                  <button
                    *ngIf="aCodePresence(row)"
                    type="button"
                    class="ga-icone"
                    title="Code de présence"
                    aria-label="Afficher le code de présence"
                    (click)="openPresenceCodeModal(row)"
                  >
                    <svg
                      class="ga-c-indigo"
                      viewBox="0 0 512 512"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
                      />
                    </svg>
                  </button>

                  <!-- Lien du formulaire (activité informelle) -->
                  <button
                    *ngIf="row.activityType == 'COMMERCANT_LIVREUR'"
                    type="button"
                    class="ga-icone"
                    [title]="
                      copiedRowId === row.id ? 'Copié !' : 'Copier le lien'
                    "
                    [attr.aria-label]="
                      copiedRowId === row.id
                        ? 'Lien copié'
                        : 'Copier le lien du formulaire'
                    "
                    (click)="copyFormLink(row)"
                  >
                    <svg
                      *ngIf="copiedRowId === row.id"
                      class="ga-c-vert"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                    <svg
                      *ngIf="copiedRowId !== row.id"
                      class="ga-c-indigo"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                      />
                      <path
                        d="M14 11a5 5 0 0 0-7.07 0l-2.83 2.83a5 5 0 0 0 7.07 7.07l1.71-1.71"
                      />
                    </svg>
                  </button>
                </div>
              </article>

              <!-- Aucun résultat -->
              <div
                *ngIf="!loading && listActivity?.length === 0"
                class="ga-vide"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  aria-hidden="true"
                >
                  <rect x="3" y="5" width="18" height="16" rx="2" />
                  <path d="M3 10h18M8 3v4M16 3v4" />
                </svg>
                <p class="ga-vide__titre">Aucune activité trouvée</p>
                <p>
                  Modifie les filtres ou la recherche pour élargir les
                  résultats.
                </p>
              </div>
            </div>
            <!-- ===== FIN MODIF ===== -->
          </div>
          <mat-paginator
            [length]="totalElements"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 20, 30, 50, 100]"
            [pageIndex]="currentPage"
            [disabled]="loading"
            (page)="onPageChange($event)"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>

        <!-- ===== DÉBUT REFONTE : détails de l'activité (gestionnaire), en lecture seule ===== -->
        <!-- « Modifier » ouvre le formulaire complet ; l'ancien petit formulaire a été supprimé -->
        <div
          *ngIf="showDetails && profil == 4"
          class="gd-overlay"
          (click)="closeModalDetails()"
        >
          <div
            class="gd-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="gd-titre"
            (click)="$event.stopPropagation()"
          >
            <!-- En-tête : type, statut, pays, titre -->
            <header class="gd-entete">
              <div class="gd-pastilles">
                <span
                  class="ga-pill"
                  [ngClass]="classeType(activity.activityType)"
                >
                  {{ libelleTypeActivite(activity.activityType) | titlecase }}
                </span>
                <span
                  class="ga-pill"
                  [ngClass]="statutActivite(activity).classe"
                >
                  <i class="ga-point" aria-hidden="true"></i
                  >{{ statutActivite(activity).libelle }}
                </span>
                <span class="gd-pays">
                  <i
                    class="ga-drapeau"
                    [ngClass]="'ga-drapeau--' + paysActivite(activity)"
                    aria-hidden="true"
                  ></i>
                  {{ paysActivite(activity) === "bj" ? "Bénin" : "Sénégal" }}
                </span>
              </div>
              <h2 id="gd-titre" class="gd-titre">{{ activity.nomActivity }}</h2>
              <p class="gd-meta" *ngIf="activity.createdAt">
                Créée le {{ activity.createdAt | date: "d MMM y" : "" : "fr" }}
                <ng-container
                  *ngIf="
                    activity.updatedAt &&
                    (activity.updatedAt | date: 'yMMdd') !==
                      (activity.createdAt | date: 'yMMdd')
                  "
                >
                  · Modifiée le
                  {{ activity.updatedAt | date: "d MMM y" : "" : "fr" }}
                </ng-container>
              </p>
              <button
                type="button"
                class="gd-fermer"
                (click)="closeModalDetails()"
                aria-label="Fermer"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  aria-hidden="true"
                >
                  <path d="M6 6l12 12M18 6L6 18" />
                </svg>
              </button>
            </header>

            <div class="gd-corps">
              <!-- Erreur (chargement des sessions, suppression) -->
              <div class="gd-erreur" role="alert" *ngIf="erreurDetails">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 8v5M12 16.5v.5" />
                </svg>
                <span>{{ erreurDetails }}</span>
              </div>

              <div class="gd-grille">
                <!-- Période -->
                <div class="gd-bloc">
                  <span class="gd-icone">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <rect x="3" y="5" width="18" height="16" rx="2" />
                      <path d="M3 10h18M8 3v4M16 3v4" />
                    </svg>
                  </span>
                  <div>
                    <p class="gd-label">Période</p>
                    <p class="gd-valeur">
                      <ng-container
                        *ngIf="
                          activity.closeDate &&
                            activity.closeDate !== activity.openDate;
                          else gdUnJour
                        "
                      >
                        Du
                        {{
                          activity.openDate | date: "EEEE d MMMM" : "" : "fr"
                        }}
                        au
                        {{
                          activity.closeDate | date: "EEEE d MMMM y" : "" : "fr"
                        }}
                      </ng-container>
                      <ng-template #gdUnJour>
                        Le
                        {{
                          activity.openDate | date: "EEEE d MMMM y" : "" : "fr"
                        }}
                      </ng-template>
                    </p>
                    <p class="gd-detail" *ngIf="heureCourte(activity.hours)">
                      {{ estInformelle(activity) ? "Premier créneau à" : "À" }}
                      {{ heureCourte(activity.hours) }}
                    </p>
                  </div>
                </div>

                <!-- Adresse -->
                <div class="gd-bloc">
                  <span class="gd-icone">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M12 21s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z"
                      />
                      <circle cx="12" cy="9" r="2.5" />
                    </svg>
                  </span>
                  <div>
                    <p class="gd-label">Adresse</p>
                    <p class="gd-valeur" [class.gd-vide]="!activity.adresse">
                      {{ activity.adresse || "Non renseignée" }}
                    </p>
                    <p class="gd-detail" *ngIf="estInformelle(activity)">
                      Lieux détaillés dans les sessions
                    </p>
                  </div>
                </div>

                <!-- Lien d'accès -->
                <div class="gd-bloc">
                  <span class="gd-icone">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"
                      />
                      <path
                        d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"
                      />
                    </svg>
                  </span>
                  <div class="gd-bloc__texte">
                    <p class="gd-label">Lien d'accès</p>
                    <div
                      class="gd-lien"
                      *ngIf="activity.accessLink; else gdSansLien"
                    >
                      <a
                        [href]="lienAbsolu(activity.accessLink)"
                        target="_blank"
                        rel="noopener"
                        [title]="activity.accessLink"
                        >{{ activity.accessLink }}</a
                      >
                      <button
                        type="button"
                        class="gd-copier"
                        (click)="copierLienAcces(activity.accessLink)"
                        [attr.aria-label]="
                          lienAccesCopie ? 'Lien copié' : 'Copier le lien'
                        "
                        [title]="lienAccesCopie ? 'Copié !' : 'Copier le lien'"
                      >
                        <svg
                          *ngIf="!lienAccesCopie"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          aria-hidden="true"
                        >
                          <rect x="9" y="9" width="11" height="11" rx="2" />
                          <path d="M5 15V5a2 2 0 0 1 2-2h8" />
                        </svg>
                        <svg
                          *ngIf="lienAccesCopie"
                          class="gd-ok"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          aria-hidden="true"
                        >
                          <path d="M5 12.5l4.5 4.5L19 7.5" />
                        </svg>
                      </button>
                    </div>
                    <ng-template #gdSansLien>
                      <p class="gd-valeur gd-vide">Aucun lien</p>
                    </ng-template>
                  </div>
                </div>

                <!-- Public (seulement pour les types qui en ont un) -->
                <div class="gd-bloc" *ngIf="publicActivite(activity) as pub">
                  <span class="gd-icone">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <circle cx="9" cy="8" r="3.5" />
                      <path d="M2.5 20c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5" />
                      <path
                        d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 13.8c2 .8 3.5 3 3.5 6.2"
                      />
                    </svg>
                  </span>
                  <div>
                    <p class="gd-label">Public</p>
                    <p class="gd-valeur">{{ pub.titre }}</p>
                    <p class="gd-detail" *ngIf="pub.detail">{{ pub.detail }}</p>
                  </div>
                </div>
              </div>

              <!-- Description -->
              <ng-container *ngIf="activity.description">
                <p class="gd-section">Description</p>
                <p class="gd-description">{{ activity.description }}</p>
              </ng-container>

              <!-- Lieux et sessions (Activité informelle) -->
              <ng-container *ngIf="estInformelle(activity)">
                <p class="gd-section">
                  Lieux et sessions
                  <span *ngIf="lieuxDetails.length">{{
                    resumeLieuxDetails
                  }}</span>
                </p>
                <p class="gd-attente" *ngIf="chargementLieux">
                  Chargement des sessions…
                </p>
                <p
                  class="gd-attente"
                  *ngIf="
                    !chargementLieux && !lieuxDetails.length && !erreurDetails
                  "
                >
                  Aucune session enregistrée.
                </p>
                <div class="gd-ville" *ngFor="let lieu of lieuxDetails">
                  <div class="gd-ville__entete">
                    <b>
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                      >
                        <path
                          d="M12 21s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z"
                        />
                        <circle cx="12" cy="9" r="2.5" />
                      </svg>
                      {{ lieu.ville }}
                    </b>
                    <span>
                      {{ lieu.jours.length }} jour{{
                        lieu.jours.length > 1 ? "s" : ""
                      }}
                      · {{ nbCreneauxLieu(lieu) }} créneau{{
                        nbCreneauxLieu(lieu) > 1 ? "x" : ""
                      }}
                    </span>
                  </div>
                  <div class="gd-jour" *ngFor="let jour of lieu.jours">
                    <span class="gd-jour__date"
                      >{{ jour.date | date: "EEEE d MMMM" : "" : "fr"
                      }}<em *ngIf="jour.salle"> · {{ jour.salle }}</em></span
                    >
                    <span class="gd-creneaux">
                      <span *ngFor="let c of jour.creneaux"
                        >{{ heureCourte(c.debut) }} –
                        {{ heureCourte(c.fin) }}</span
                      >
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- Pied : actions -->
            <footer class="gd-pied">
              <ng-container *ngIf="peutModifier(activity); else gdLectureSeule">
                <button
                  type="button"
                  class="gd-btn gd-btn--danger"
                  (click)="onDelete(activity.id)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"
                    />
                  </svg>
                  Supprimer
                </button>
                <div class="gd-pied__droite">
                  <button
                    type="button"
                    class="gd-btn gd-btn--secondaire"
                    (click)="closeModalDetails()"
                  >
                    Fermer
                  </button>
                  <button
                    type="button"
                    class="gd-btn gd-btn--primaire"
                    (click)="modifierActivite(activity)"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z" />
                      <path d="M13.5 6.5l4 4" />
                    </svg>
                    Modifier
                  </button>
                </div>
              </ng-container>
              <ng-template #gdLectureSeule>
                <p class="gd-note">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                  </svg>
                  Seul un administrateur peut modifier ou supprimer un Atelier
                  Force-N.
                </p>
                <button
                  type="button"
                  class="gd-btn gd-btn--secondaire"
                  (click)="closeModalDetails()"
                >
                  Fermer
                </button>
              </ng-template>
            </footer>
          </div>
        </div>
        <!-- ===== FIN REFONTE : détails de l'activité ===== -->

        <!-- ===== DÉBUT REFONTE : confirmation de suppression ===== -->
        <!-- Le back refuse (409) s'il y a déjà des inscrits : on propose de fermer l'activité -->
        <div
          *ngIf="showDeleteModal"
          class="gs-overlay"
          (click)="suppressionEnCours ? null : closeDeleteModal()"
        >
          <div
            class="gs-dialog"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="gs-titre"
            aria-describedby="gs-texte"
            (click)="$event.stopPropagation()"
          >
            <!-- Cas 1 : confirmation, avec ce que la suppression emporte -->
            <ng-container *ngIf="!suppressionRefusee; else gsRefus">
              <div class="gs-corps">
                <span class="gs-icone gs-icone--danger">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"
                    />
                  </svg>
                </span>
                <h3 id="gs-titre" class="gs-titre">
                  Supprimer cette activité ?
                </h3>
                <p id="gs-texte" class="gs-texte">
                  <b>{{ activityToDelete?.nomActivity }}</b> sera supprimée
                  définitivement. Cette action est irréversible.
                </p>

                <div class="gs-impact">
                  <p *ngIf="chargementImpact" class="gs-impact__attente">
                    Vérification des inscrits…
                  </p>
                  <ng-container *ngIf="impactSuppression as impact">
                    <p *ngIf="impact.sessions">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                      >
                        <rect x="3" y="5" width="18" height="16" rx="2" />
                        <path d="M3 10h18M8 3v4M16 3v4" />
                      </svg>
                      {{ texteImpactSessions }}
                    </p>
                    <p [class.gs-impact__alerte]="impact.personnes > 0">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                      >
                        <circle cx="9" cy="8" r="3.5" />
                        <path
                          d="M2.5 20c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5"
                        />
                        <path
                          d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 13.8c2 .8 3.5 3 3.5 6.2"
                        />
                      </svg>
                      {{ texteImpactPersonnes }}
                    </p>
                  </ng-container>
                </div>

                <!-- Confirmations ou présences : il faut cocher avant de supprimer -->
                <label class="gs-compris" *ngIf="confirmationRenforcee">
                  <input type="checkbox" [(ngModel)]="comprisSuppression" />
                  <span>
                    Je comprends que leurs confirmations et leurs présences
                    seront définitivement perdues.
                  </span>
                </label>

                <div class="gs-erreur" role="alert" *ngIf="erreurSuppression">
                  {{ erreurSuppression }}
                </div>
              </div>
              <div class="gs-pied">
                <button
                  type="button"
                  class="gd-btn gd-btn--secondaire"
                  (click)="closeDeleteModal()"
                  [disabled]="suppressionEnCours"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  class="gd-btn gd-btn--danger-plein"
                  (click)="confirmDelete()"
                  [disabled]="suppressionImpossibleAppel"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"
                    />
                  </svg>
                  {{
                    suppressionEnCours
                      ? "Suppression…"
                      : "Supprimer définitivement"
                  }}
                </button>
              </div>
            </ng-container>

            <!-- Cas 2 : le back refuse, l'activité a déjà des inscrits -->
            <ng-template #gsRefus>
              <div class="gs-corps">
                <span class="gs-icone gs-icone--alerte">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                  </svg>
                </span>
                <h3 id="gs-titre" class="gs-titre">Suppression impossible</h3>
                <p id="gs-texte" class="gs-texte">{{ suppressionRefusee }}</p>
                <div class="gs-astuce">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 11v5M12 8v.01" />
                  </svg>
                  <span *ngIf="!activityToDelete?.isClosed">
                    Ferme-la plutôt : plus personne ne pourra s'inscrire ni
                    confirmer, et tout l'historique est conservé.
                  </span>
                  <span *ngIf="activityToDelete?.isClosed">
                    Elle est déjà fermée : plus personne ne peut s'inscrire ni
                    confirmer, et tout l'historique est conservé.
                  </span>
                </div>
                <div class="gs-erreur" role="alert" *ngIf="erreurSuppression">
                  {{ erreurSuppression }}
                </div>
              </div>
              <div class="gs-pied">
                <button
                  type="button"
                  class="gd-btn gd-btn--secondaire"
                  (click)="closeDeleteModal()"
                  [disabled]="suppressionEnCours"
                >
                  {{ activityToDelete?.isClosed ? "Compris" : "Annuler" }}
                </button>
                <button
                  *ngIf="!activityToDelete?.isClosed"
                  type="button"
                  class="gd-btn gd-btn--primaire"
                  (click)="fermerActiviteApresRefus()"
                  [disabled]="suppressionEnCours"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                  </svg>
                  {{ suppressionEnCours ? "Fermeture…" : "Fermer l'activité" }}
                </button>
              </div>
            </ng-template>
          </div>
        </div>
        <!-- ===== FIN REFONTE : confirmation de suppression ===== -->

        <!-- Modal fermeture / ouverture d'activité -->
        <div
          *ngIf="showModalClosure"
          tabindex="-1"
          style="z-index: 99999"
          class="fixed inset-0 flex items-center justify-center bg-slate-900/50 px-4"
          (click)="closeClosureModal()"
        >
          <div
            class="w-full max-w-xl overflow-hidden rounded-3xl bg-white shadow-2xl dark:bg-gray-800"
            role="dialog"
            aria-modal="true"
            (click)="$event.stopPropagation()"
          >
            <!-- En-tête -->
            <div
              class="flex items-start justify-between gap-4 border-b border-gray-200 px-8 py-6 dark:border-gray-700"
            >
              <div>
                <p class="text-xl font-semibold text-gray-900 dark:text-white">
                  {{
                    activityToToggle?.isClosed
                      ? "Rouvrir l'activité"
                      : "Fermer l'activité"
                  }}
                </p>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {{ activityToToggle?.nomActivity | titlecase }}
                </p>
              </div>
              <button
                type="button"
                (click)="closeClosureModal()"
                class="text-gray-400 hover:text-gray-600"
                aria-label="Fermer la fenêtre"
              >
                <svg
                  width="22"
                  height="22"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <!-- Corps -->
            <div class="px-8 py-8">
              <!-- Icône -->
              <div
                class="mx-auto flex h-16 w-16 items-center justify-center rounded-full"
                [ngClass]="
                  activityToToggle?.isClosed ? 'bg-green-50' : 'bg-red-50'
                "
              >
                <!-- Cadenas ouvert → on va rouvrir -->
                <svg
                  *ngIf="activityToToggle?.isClosed"
                  width="30"
                  height="30"
                  class="text-green-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.8"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.5 10.5V6.75a4.5 4.5 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                  />
                </svg>
                <!-- Cadenas fermé → on va fermer -->
                <svg
                  *ngIf="!activityToToggle?.isClosed"
                  width="30"
                  height="30"
                  class="text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.8"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                  />
                </svg>
              </div>

              <!-- Message -->
              <p
                class="mt-6 text-lg text-center leading-relaxed text-gray-700 dark:text-gray-400"
              >
                <!-- Cas fermeture -->
                <ng-container *ngIf="!activityToToggle?.isClosed">
                  Vous êtes sur le point de <strong>fermer</strong> l'activité
                  <strong>{{ activityToToggle?.nomActivity }}</strong
                  >.<br />
                  Plus personne ne pourra confirmer sa participation après cette
                  action.
                </ng-container>
                <!-- Cas réouverture -->
                <ng-container *ngIf="activityToToggle?.isClosed">
                  Vous êtes sur le point de <strong>rouvrir</strong> l'activité
                  <strong>{{ activityToToggle?.nomActivity }}</strong
                  >.<br />
                  Les participants pourront à nouveau confirmer leur
                  participation.
                </ng-container>
              </p>

              <!-- Boutons -->
              <div class="mt-8 grid grid-cols-2 gap-4">
                <button
                  type="button"
                  (click)="closeClosureModal()"
                  class="h-14 rounded-xl border border-gray-300 bg-white text-base font-semibold text-gray-800 hover:bg-gray-50"
                >
                  Annuler
                </button>
                <button
                  type="button"
                  (click)="confirmToggleActivityClosure()"
                  class="h-14 rounded-xl text-base font-semibold text-white"
                  [ngClass]="
                    activityToToggle?.isClosed
                      ? 'bg-green-600 hover:bg-green-700'
                      : 'bg-red-600 hover:bg-red-700'
                  "
                >
                  {{ activityToToggle?.isClosed ? "Rouvrir" : "Fermer" }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal code de présence -->
        <div
          *ngIf="showModalPresenceCode"
          tabindex="-1"
          style="z-index: 99999"
          class="fixed inset-0 flex items-center justify-center bg-slate-900/50 px-4"
          (click)="closePresenceCodeModal()"
        >
          <div
            class="w-full max-w-xl overflow-hidden rounded-3xl bg-white shadow-2xl dark:bg-gray-800"
            role="dialog"
            aria-modal="true"
            (click)="$event.stopPropagation()"
          >
            <!-- En-tête -->
            <div
              class="flex items-start justify-between gap-4 border-b border-gray-200 px-8 py-6 dark:border-gray-700"
            >
              <div>
                <p class="text-xl font-semibold text-gray-900 dark:text-white">
                  Code de présence
                </p>
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {{ presenceCodeActivity?.nomActivity | titlecase }}
                </p>
              </div>
              <button
                type="button"
                (click)="closePresenceCodeModal()"
                class="text-gray-400 hover:text-gray-600"
                aria-label="Fermer la fenêtre"
              >
                <svg
                  width="22"
                  height="22"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <!-- Corps -->
            <div class="px-8 py-8">
              <!-- Icône -->
              <div
                class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blue-50"
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                  class="text-[#1565A8]"
                  aria-hidden="true"
                >
                  <path
                    d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
                  />
                </svg>
              </div>

              <!-- Chargement -->
              <p
                *ngIf="presenceCodeLoading"
                class="mt-6 text-lg text-center text-gray-500"
              >
                Chargement…
              </p>

              <!-- Erreur -->
              <ng-container *ngIf="presenceCodeError && !presenceCodeLoading">
                <p
                  class="mt-6 text-lg text-center leading-relaxed text-gray-700 dark:text-gray-400"
                >
                  {{ presenceCodeError }}
                </p>
                <div class="mt-8">
                  <button
                    type="button"
                    (click)="closePresenceCodeModal()"
                    class="h-14 w-full rounded-xl border border-gray-300 bg-white text-base font-semibold text-gray-800 hover:bg-gray-50"
                  >
                    Fermer
                  </button>
                </div>
              </ng-container>

              <!-- Activité terminée -->
              <ng-container
                *ngIf="
                  presenceCode?.expired &&
                  !presenceCodeLoading &&
                  !presenceCodeError
                "
              >
                <p
                  class="mt-6 text-lg text-center leading-relaxed text-gray-700 dark:text-gray-400"
                >
                  L'activité
                  <strong>{{ presenceCodeActivity?.nomActivity }}</strong> est
                  terminée.<br />
                  Plus aucune présence ne peut être validée. Pour toute demande,
                  rapprochez-vous de l'administrateur.
                </p>
                <div class="mt-8">
                  <button
                    type="button"
                    (click)="closePresenceCodeModal()"
                    class="h-14 w-full rounded-xl border border-gray-300 bg-white text-base font-semibold text-gray-800 hover:bg-gray-50"
                  >
                    Fermer
                  </button>
                </div>
              </ng-container>

              <!-- Code actif -->
              <ng-container
                *ngIf="
                  presenceCode &&
                  !presenceCode.expired &&
                  !presenceCodeLoading &&
                  !presenceCodeError
                "
              >
                <p
                  class="mt-6 text-center font-mono text-5xl font-semibold tracking-[0.4em] text-gray-900 dark:text-white"
                >
                  {{ presenceCode.code }}
                </p>
                <p
                  *ngIf="presenceCode.validUntil"
                  class="mt-3 text-center text-sm text-gray-500"
                >
                  Valable jusqu'au
                  {{ presenceCode.validUntil | date: "d MMM y, HH:mm" }}
                </p>

                <p
                  class="mt-6 text-lg text-center leading-relaxed text-gray-700 dark:text-gray-400"
                >
                  Communiquez ce code aux agents qui scannent les QR codes.<br />
                  Il ne fonctionne que pour l'activité
                  <strong>{{ presenceCodeActivity?.nomActivity }}</strong
                  >.
                </p>

                <p
                  *ngIf="confirmRegenerate"
                  class="mt-5 rounded-xl bg-amber-50 px-4 py-3 text-center text-sm text-amber-800"
                >
                  L'ancien code ne fonctionnera plus pour les agents. Cliquez
                  sur "Confirmer" pour le remplacer.
                </p>

                <!-- Boutons -->
                <div class="mt-8 grid grid-cols-2 gap-4">
                  <button
                    type="button"
                    (click)="regeneratePresenceCode()"
                    class="h-14 rounded-xl border bg-white text-base font-semibold"
                    [ngClass]="
                      confirmRegenerate
                        ? 'border-amber-400 text-amber-800'
                        : 'border-gray-300 text-gray-800 hover:bg-gray-50'
                    "
                  >
                    {{ confirmRegenerate ? "Confirmer" : "Régénérer" }}
                  </button>
                  <button
                    type="button"
                    (click)="copyPresenceCode()"
                    class="h-14 rounded-xl bg-[#1565A8] text-base font-semibold text-white hover:opacity-90"
                  >
                    {{ presenceCodeCopied ? "Copié !" : "Copier le code" }}
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #moduleIndisponible>
  <div
    class="w-full h-[70vh] flex flex-col items-center justify-center gap-4 bg-zinc-100 rounded-lg"
  >
    <div
      class="bg-white rounded-xl shadow-sm px-10 py-12 flex flex-col items-center gap-4 max-w-md text-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-14 h-14 text-slate-400"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9.75 9.75a2.25 2.25 0 1 1 4.5 0c0 1.5-2.25 1.5-2.25 3.75M12 17.25h.008v.008H12v-.008Z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75Z"
        />
      </svg>
      <h2 class="text-xl font-semibold text-slate-800">
        Ce module n'est pas encore disponible
      </h2>
      <p class="text-slate-500 text-sm">
        Cette fonctionnalité sera bientôt accessible.
      </p>
    </div>
  </div>
</ng-template>
